import { Warning } from '@/components'
import { useCheditor } from '@/utils'
import { useDebounceFn } from 'ahooks'
import { Checkbox, Col, Form, Input, Alert, Radio, Select } from 'antd'
import { useEffect, useMemo, useState } from 'react'
import styled from 'styled-components'
import { useGetEducationTemplateList, usePutPhishEmail } from './utils'
import { t } from '@/i18n'
const { useForm } = Form
export const EditPhishing = props => {
  const { particulars, submit, id, acquire } = props
  console.log('particulars', particulars)
  const [form] = useForm()
  const [putPhishEmail] = usePutPhishEmail()
  let [emailContent, setEmailContent] = useState([])
  const [type, setType] = useState(particulars?.security_id === '0' ? '0' : '1')
  const [templateList, getTemplateList] = useGetEducationTemplateList()
  const onFinish = (values: any) => {
    let { redirect, name, security_id } = values

    emailContent?.map((item, index) => {
      const reg2 = /href=\"([^\"]+)/gim
      const link = item.match(reg2)
      const urls = link?.[0]?.slice(link?.[0]?.indexOf('=') + 2)
    })
    let value = editor?.getData()
    // if (value?.indexOf('<script>') > 0 && value?.indexOf('</script>') > 0) {
    //   let arr = value.split('<script>')
    //   arr.map(() => {
    //     // value.substring(value.indexOf('<script>'), value.indexOf('</script>'))
    //     if (value.indexOf('<script') > 0 && value.indexOf('</script') > 0) {
    //       value = value.replaceAll(
    //         value.substring(value.indexOf('<script'), value.indexOf('</script>') + 9),
    //         '',
    //       )
    //     }
    //   })
    // }
    if (redirect) {
      if (security_id === '1') {
        security_id = redirect
        redirect = templateList?.items?.filter(e => redirect === e.id)?.[0]?.redirect
      }
      if (security_id === '0' && !(redirect.includes('http://') || redirect.includes('https://'))) {
        redirect = `https://${redirect}`
      }
    }
    putPhishEmail({
      id,
      name,
      security_id,
      autocommit: particulars?.autocommit || 2,
      redirect: redirect,
      content: value,
    })
      .then(res => {
        acquire()
      })
      .catch(err => {})
  }
  let [content, setContent] = useState('')
  const onFinishFailed = (errorInfo: any) => {}

  useEffect(() => {
    if (submit.accomplish) {
      form.submit()
    }
  }, [submit])
  let [element, setElement] = useState<HTMLDivElement | null>(null)
  const { editor } = useCheditor({
    height: 270,
    initData: particulars?.content,
    element,
    // onKey: e => {
    //   run(e)
    // },
    onChange: e => {
      run(e)
    },
  })
  const { run } = useDebounceFn(
    value => {
      setContent(value)
      const regs = /<a .*?href="(.*?)">.*?<\/a>/gim
      setEmailContent(value.match(regs))
      // replaceFn(value)
    },
    {
      wait: 500,
    },
  )
  const replaceFn = value => {
    if (value.indexOf('window.location.replace') > 0) {
      value = value.replaceAll('window.location.replace', 'let  ddd')
      editor?.setData(value)
    }
    if (value.indexOf('window.location.href') > 0) {
      value = value.replaceAll('window.location.href', 'let  ddd')
      editor?.setData(value)
    }
    if (value?.indexOf('<script') > 0 && value?.indexOf('</script>') > 0) {
      let arr = value.split('<script')
      arr.map(() => {
        if (value.indexOf('<script') > 0 && value.indexOf('</script>') > 0) {
          value = value.replaceAll(
            value.substring(value.indexOf('<script'), value.indexOf('</script>') + 9),
            '',
          )
        }
      })
      editor?.setData(value)
    }
  }
  // useEffect(() => {
  //  replaceFn(particulars?.content)
  // }, [particulars?.content])
  useEffect(() => {
    getTemplateList({ page: 1, limit: 9999, keyword: '' }).catch(_ => {})
  }, [])
  return (
    <>
      {particulars && (
        <FomrType
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          form={form}
          initialValues={{
            name: particulars?.name,
            redirect:
              particulars?.security_id === '0'
                ? particulars?.redirect
                : particulars?.security_id !== '1'
                ? particulars?.security_id
                : null,
            autocommit: particulars?.autocommit === 1,
            security_id: particulars?.security_id === '0' ? '0' : '1',
          }}
        >
          <Form.Item
            name="name"
            label="模板名称"
            rules={[
              { required: true, message: '请输入模板名称' },
              { max: 30, message: '模板名称最多30个字符' },
              {
                pattern: /^(?=.*\S).+$/,
                message: '模板名称不能全部为空格!',
              },
            ]}
          >
            <Input placeholder="请输入" maxLength={30} />
          </Form.Item>
          {particulars?.content && (
            <Form.Item label="钓鱼页">
              <div ref={setElement} />
            </Form.Item>
          )}
          <Form.Item name="security_id" label="默认重定向页面">
            <Radio.Group
              onChange={e => {
                setType(e.target.value)
                form.setFieldValue('redirect', null)
              }}
            >
              <Radio value="0"> {t('输入自定义URL')} </Radio>
              <Radio value="1"> {t('选择安全教育模板')} </Radio>
            </Radio.Group>
          </Form.Item>
          {type === '0' && (
            <Form.Item
              name="redirect"
              // label="重定向页面"
              rules={[{ type: 'url', message: '请输入正确的重定向页面' }]}
            >
              <Input placeholder="https://example.com" />
            </Form.Item>
          )}
          {type === '1' && (
            <Form.Item
              name="redirect"
              // label="重定向页面"
              // rules={[{ type: 'url', message: '请输入正确的重定向页面' }]}
            >
              <Select
                showSearch
                optionFilterProp="label"
                style={{ width: 420 }}
                placeholder="请选择安全教育模板"
                options={templateList?.items?.map(item => ({
                  label: `${item.name}(${item.redirect})`,
                  value: item.id,
                }))}
              />
            </Form.Item>
          )}
          <Warning
            text={
              '可输入自定义URL或选择系统内置的安全教育模板作为重定向页面，并将钓鱼页面代码中的重定向页面URL改为{{.Url}}'
            }
            style={{ width: 700 }}
          />

          {/* <Form.Item name="autocommit" valuePropName="checked">
           <Checkbox value={1} style={{ lineHeight: '32px' }}>
             自动提交捕获的数据
           </Checkbox>
          </Form.Item>
          <Alert
           style={{ marginTop: '28px' }}
           message="请输入重定向页面URL后再选择是否自动提交捕获的数据，否则选择无效"
           type="warning"
           showIcon
          /> */}
        </FomrType>
      )}
    </>
  )
}

const FomrType = styled(Form)`
  padding-right: 30px;
  .subject {
    display: flex;
    width: 100%;
    justify-content: space-between;
  }
  .ant-input {
    width: 420px;
  }
  .ant-row {
    display: block;
  }
  .ant-alert-message {
    color: #ffad31;
  }
  .ant-alert-warning {
    background-color: #fff3e1;
  }
`
